@if(showSplashScreen()){
<app-splash-screen></app-splash-screen>
} @if(!online()){
<div
  class="offline-banner-wrapper bg-red-500 w-full text-white fixed top-0 left-0 right-0 z-50"
>
  <app-offline-banner></app-offline-banner>
</div>
}
<app-pwa-update-banner></app-pwa-update-banner>
<router-outlet></router-outlet>
<app-pwa-install-banner></app-pwa-install-banner>
@if(showEnablePushCta()){
<div
  class="push-cta-banner fixed top-0 left-0 right-0 z-50 bg-primary-500 text-white shadow-lg animate-slide-down"
>
  <div class="flex items-center justify-between p-4 gap-4 max-w-full">
    <div class="flex-1">
      <h3 class="font-semibold text-base">
        {{ 'shared.pwa.notifications.title' | translate }}
      </h3>
      <p class="text-surface-100 text-sm">
        {{ 'shared.pwa.notifications.description' | translate }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      <button
        (click)="enablePushNotificationsFromUserAction()"
        class="px-4 py-2 bg-surface-500 text-surface-900 text-sm font-semibold rounded-lg border border-surface-300"
      >
        {{ 'shared.pwa.notifications.enable' | translate }}
      </button>
      <button
        (click)="dismissPushCta()"
        class="px-4 py-2 bg-transparent text-white text-sm font-semibold rounded-lg border border-white"
      >
        {{ 'shared.pwa.notifications.notNow' | translate }}
      </button>
    </div>
  </div>
</div>
}
<app-error-logger-panel></app-error-logger-panel>
@if(showLoader()){
<div class="fixed inset-0 z-50 flex items-center justify-center bg-white">
  <div
    class="animate-spin rounded-full h-16 w-16 border-t-4 border-primary-500"
  ></div>
</div>
}
